import OnboardingBanner from "./OnboardingBanner.tsx";
import { ComponentPropsWithoutRef } from "react";
import AssetCoverSized from "../../../../common/features/asset/AssetCoverSized.tsx";
import styles from "./BookBanner.module.scss";

type BookBannerProps = Omit<
  ComponentPropsWithoutRef<typeof OnboardingBanner>,
  "icon"
> & {
  vbids: string[];
};

export function BookBanner({ vbids, ...bannerProps }: BookBannerProps) {
  const leftContent =
    vbids.length > 0 ? (
      <div className={styles.covers}>
        <AssetCoverSized
          vbid={vbids[0]}
          width={120}
          width2x={240}
          className={styles.cover}
        />
        {vbids[1] && (
          <AssetCoverSized
            vbid={vbids[1]}
            width={120}
            width2x={240}
            className={styles.cover}
          />
        )}
      </div>
    ) : null;

  return <OnboardingBanner {...bannerProps} leftContent={leftContent} />;
}
